function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import { Consumer } from '../components/Map';

/**
 * Provides wrapped components rendered in the component tree below Map with props for accessing the ol/Map, determining map resolution and obtaining a BAAT token.
 *
 * **Note: Wrapped components will not be rendered until the map is available.**
 *
 * This is typically used to create components that manipulate or add features to the map. Examples includes most components in this package.
 *
 * This HOC makes it possible to implement own components that provide map functionality.
 *
 * @component
 */
export function ensureMap(WrappedComponent) {
  var MapConsumer = /*#__PURE__*/function (_React$Component) {
    function MapConsumer() {
      return _React$Component.apply(this, arguments) || this;
    }
    _inheritsLoose(MapConsumer, _React$Component);
    var _proto = MapConsumer.prototype;
    _proto.render = function render() {
      var _this = this;
      return /*#__PURE__*/React.createElement(Consumer, null, function (mapContext) {
        if (!mapContext.map) return;
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
          map: mapContext.map,
          getResolution: mapContext.getResolution,
          baatToken: mapContext.baatToken
        }, _this.props));
      });
    };
    return MapConsumer;
  }(React.Component);
  return MapConsumer;
}